import React, { useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';
import logo from '../../assets/primary_logo.webp';
import loginImage from '../../assets/loginImage.webp';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  console.info('LoginPage mounted');
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const autoLogin = searchParams.get('auto') === 'true';

  useEffect(() => {
    // If user is already authenticated, redirect them
    if (isAuthenticated) {
      // Get returnTo from URL params or appState
      console.info('User is authenticated');
      const returnTo = searchParams.get('returnTo') ||
        JSON.parse(sessionStorage.getItem('auth_redirect_in_progress') || '{}')?.returnTo ||
        '/';
      // Clean up session storage
      console.info('Cleaning up session storage');
      sessionStorage.removeItem('auth_redirect_in_progress');
      // Redirect to the appropriate page
      console.log('Redirecting to:', returnTo);
      navigate(returnTo, { replace: true });
      return;
    }
    // Handle auto-login if specified
    if (!isAuthenticated && autoLogin) {
      console.info('Auto-login initiated');
      loginWithRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, navigate, autoLogin, loginWithRedirect, searchParams]);

  // If user is authenticated, don't render the login page
  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-hero">
          <img src={loginImage} alt="Study Abroad Illustration" />
        </div>

        <div className="login-form-side">
          <img src={logo} alt="FuturX Logo" className="login-logo" />
          <h1 className="login-title">Welcome Back</h1>
          <p className="login-subtitle">Please sign in to your account</p>

          <Button
            type="primary"
            size="large"
            className="login-button"
            onClick={() => {
              console.info('Login button clicked');
              loginWithRedirect();
            }}
            loading={isLoading}
          >
            {isLoading ? 'Connecting...' : 'Login'}
          </Button>

          <div className="login-footer">
            By continuing, you agree to our Terms of Service
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 